<template>
  <v-row class="d-flex justify-center ma-0 pa-0 fill-height">
    <v-col cols="12" lg="10" md="7">
      <v-card class="card-shadow bg-secondary">
        <ExibicaoPromocaoAgente />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ExibicaoPromocaoAgente from "../Components/Exibicoes/ExibicaoPromocaoAgente.vue";
export default {
  name: "ShowPromoAgent",
  components: {
    ExibicaoPromocaoAgente,
  },
  data() {
    return {};
  },
};
</script>
